// shared/ has no slice, so no model/ to hold hooks — colocate the hook next to
// the component per spec §4.3 (docs/superpowers/specs/2026-07-30-separate-ui-logic-design.md).
import { useMediaQuery } from '@/shared/lib/customHooks';
import { useEffect, useState } from 'react';

/**
 * Drives the shared modal layout wrapper: responsive breakpoint, open state and editable title. Mirrors the open and title props into local state through effects, reports whether the viewport is at most 599px wide, and closes by clearing open then forwarding onCancel after Ant Design's 200ms animation.
 *
 * @param props - Modal props supplying open, title and the onCancel callback.
 * @returns Modal state with the mobile flag, open flag, title, close handler and title setter.
 */
export const useWithModalLayout = (props: any) => {
  const isMobile = useMediaQuery('(max-width: 599px)');

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    setTitle(props.title);
  }, [props.title]);

  /**
   * Closes the modal and forwards the cancel event with its optional payload to the parent. Clears the open state immediately and defers onCancel by 200ms to match Ant Design's animation duration.
   *
   * @param param - Optional value passed through to the parent onCancel callback.
   * @returns Nothing.
   */
  const handleClose = (param?: any) => {
    setOpen(false);
    setTimeout(() => {
      props.onCancel(param);
    }, 200); // Set the delay to the Drawer's animation duration (200ms by default in Ant Design)
  };

  return { isMobile, open, title, handleClose, setTitle };
};
